import { render, staticRenderFns } from "./technician-statistics.vue?vue&type=template&id=0fa43b69&scoped=true&"
import script from "./technician-statistics.vue?vue&type=script&lang=js&"
export * from "./technician-statistics.vue?vue&type=script&lang=js&"
import style0 from "./technician-statistics.vue?vue&type=style&index=0&id=0fa43b69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa43b69",
  null
  
)

export default component.exports